import { configureStore } from '@reduxjs/toolkit';
import chargerSlice from './slices/charger-slice';
import userSlice from './slices/user-slice';
import navigationSlice from './slices/navigation-slice';

const store = configureStore({
    reducer: {
        chargers: chargerSlice.reducer,
        user: userSlice.reducer,
        navigation: navigationSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck:false,
        }),
}); 

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch; // Define the dispatch type here

export default store;